var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_DataView.js
// module id = 1628
// module chunks = 3 9 13